import { Inject, Component, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-package-list-create",
  templateUrl: "./package-list-create.component.html",
  styleUrls: ["./package-list-create.component.scss"],
  imports: [FormsModule, MatDialogModule],
})
export class PackageListCreateComponent implements OnInit {
  public name: string = "";
  constructor(
    public dialogRef: MatDialogRef<PackageListCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    // This is intentional
  }

  cancel(): void {
    this.name = "";
    this.dialogRef.close();
  }
  confirm() {
    this.dialogRef.close(this.name);
  }
}
